import React from 'react';

const Context = React.createContext({});
export const useProfileContext = () => React.useContext(Context);

export default Context;
